import { render, staticRenderFns } from "./LifestyleExtensions.vue?vue&type=template&id=0d91eaf1&scoped=true"
import script from "./LifestyleExtensions.vue?vue&type=script&lang=js"
export * from "./LifestyleExtensions.vue?vue&type=script&lang=js"
import style0 from "./LifestyleExtensions.vue?vue&type=style&index=0&id=0d91eaf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d91eaf1",
  null
  
)

export default component.exports